import {createAsyncThunk} from '@reduxjs/toolkit'

import {qs} from '@shared/helpers/queryString'

import {getCardReRegisterUrl, PAY_M} from '@web/core/urls'
import {changeBrowserLocation, openNewTab} from '@web/helpers/browser'
import {examineUrlSafety} from '@web/helpers/path'
import {isMobile} from '@web/helpers/userAgent'
import {LanguageType} from '@web/i18n'

import {LocationChangeHistoryParam, NavigationResult, NavigationTypeSelectableParam, ThunkApi} from '../interfaces'

/**
 * 카드 셋팅 페이지 이동
 */
const navigateToCardSetting = createAsyncThunk<
    NavigationResult,
    {language: LanguageType; isAnonymousUser: boolean} & (
        | (NavigationTypeSelectableParam & LocationChangeHistoryParam)
        | void
    ),
    ThunkApi
>('navigateTo/cardSetting', async (args) => {
    const {forceLocationChange = false, historyType = 'PUSH'} = args ?? {}
    const shouldChangeLocation = forceLocationChange || isMobile
    const url = qs.stringifyUrl({
        url: args.isAnonymousUser
            ? getCardReRegisterUrl({language: args.language})
            : `${PAY_M}/mobile/setting/card/info`,
        query: args.isAnonymousUser
            ? {
                  rurl: examineUrlSafety(window.location.href, ''),
              }
            : {
                  backUrl: examineUrlSafety(window.location.href, ''),
              },
    })

    if (shouldChangeLocation) {
        changeBrowserLocation({
            url,
            type: historyType,
        })
        // page 이동은 그 자체로 추가동작 없이 resolve 된다
        return Promise.resolve()
    }

    openNewTab({url})
})

export default navigateToCardSetting
